import { GetIconComponent, IconInfo } from '@bimser/icons';
import { Tabs } from 'antd';
import classNames from 'classnames/bind';
import * as React from 'react';
import BCScrollbars from '../BCScrollbars';
import Styles from './assets/style.scss';
import { ITabItem, ITabProps } from './entities';

const cx = classNames.bind(Styles);

const BCTabs = ({ readOnly, seleniumId, cssClass, ...props }: ITabProps) => {
	const className: string = cx({
		readOnlyCursor: readOnly,
		tabContainer: true,
		[cssClass]: !!cssClass
	});

	return (
		<Tabs
			{...props}
			className={className}
			tabBarGutter={0}
			data-selenium-id={seleniumId}
		/>
	);
};

const BCTabItemWithIcon = (props: { label: string; icon?: IconInfo }) => (
	<>
		{GetIconComponent(props.icon)}
		<span title={props.label}>{props.label}</span>
	</>
);

const BCTabContentWithScroll = (props: { children: React.ReactNode }) => (
	<BCScrollbars>{props.children}</BCScrollbars>
);

export default BCTabs;
export { BCTabContentWithScroll, BCTabItemWithIcon, ITabItem, ITabProps };
